import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { setRegPage, setDeviceConfigFailed, setDisableOrderPopup, setShowCustomPopup } from '../../../action/action'
import { getItemListStoreLevel1, defaultStoreItemList, selectedFood, selectedNavComponent, getItemType, 
    changePage, selectedStoreItemType, getSubItemType, selectedSubItem, setDefaultSubTypeList, setSelectedSubItemList, setSelectedStoreItemList, setSelectedStoreSubMenuList,
    setTotalOrderPrice, setHCommerceSavedOrders, getStoreInfo } from '../../../action/hcommerce'
import { CLICKED, CMSPath } from '../../../config/constant'
import { hCommColor } from '../../JS/colorConfig'
import { setGoHome, setLoginRequired, setSelectedList } from '../../action/homeAction'
import { dynamicHeight } from '../../JS/listItemHeightFix';
import AddOnPopup from './addOnPopup/addOnPopup';
import $ from 'jquery'
import { totalPriceCal } from '../../JS/totalPriceCal'
import { closeOrderPopUp } from '../../action/hCommerce2'
import { addToMyOrder, formatPriceForDisplay } from './itemActions' 
import Loader from '../../UI/loader';
import {withTranslation} from "react-i18next";
import SuccessFailScreen from '../../UI/SuccessFailScreen'
import { extractIdsOfStoreData, getCleanUrl, getDefaultAnalyticsLabel } from '../../JS/utility'
import OrderDisabledPopup from './OrderDisabledPopup'
import { setHcommerceWidget } from '../../action/hCommerce2'

import { contScrollToBottom, contScrollToTop, hideScrolltoTopHandler, hideScrolltoBottomHandler } from '../../JS/scroll';
import { setWarningPopup } from '../../../action/homeAction'
import { sendAnalytics } from '../../../action/homeAction'
import { getCdnUrl } from '../../../config/config'

class StoreLevel1 extends Component {

    constructor(props) {
        super(props)
        this.state = {
            clickSelectList: false,
            showAddOn:false,
            addOn:[],
            quantity:1,
            itemsHaveAddonsList: [],
            getItemTypeLoading:false,
            getSubItemTypeLoading:false,
            getItemListStoreLevel1Loading:true,
            showFailscreen: false,
            getItemListAPICallCount: 0,
            getItemTypeAPICallCount : 0,
            getSubItemTypeAPICallCount: 0,
            showLoader: true,
            hideBottomArrow: true,
            showScrollToTop: true
        }
        this.selected = null;
        this.timeout = null;
        this.storeLevel1EventSent = localStorage.getItem("storeLevel1EventSent") == "true";
        this.storeInfoFetchEventSent = localStorage.getItem("storeInfoFetchEventSent") == "true";
    }

    

    sendGAEvent = (action, message, callback, extraLabelInfo) => {
        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        
        this.props.sendAnalytics(
            this.props.guestDetail, 
            this.props.currentWidgets.widgetType, 
            action, 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "errorMessage": message && message, "widgetSessionId": localStorage.getItem("hcommerceSessionToken"), ...extraLabelInfo, storeName: this.props.storeInfo.storeName, pageName: "STORE LEVEL - 1"},
            0, 
            this.props.guestIsLoggedIn,
            callback ? callback : false
        );
    }

    tryAgain = () => {
        this.setState({
            showFailscreen: false,
            showLoader: true
        })
        // this.reInitCancelTokens()
        // this.apiCalls()
        this.props.getStoreInfo(this.props.currentWidget.storeSku, this.props.guestDetail, (status, message) => {
            this.setState({showLoader: false})
            if(status){

                // added support for "ALL"
                // this.selectStore(this.props.itemTypeList[0])

                clearTimeout(this.timeout)
                if(localStorage.getItem("storeInfoFetchEventSent") !== "true" && !this.storeInfoFetchEventSent){
                    this.storeInfoFetchEventSent = true
                    this.sendGAEvent("STORE INFO FETCH - SUCCESS", "", () => localStorage.setItem("storeInfoFetchEventSent", true))
                }
                // if(localStorage.getItem("storeLevel1EventSent") !== "true" && !this.storeLevel1EventSent){
                //     this.storeLevel1EventSent = true
                //     // Send Analytics
                //     this.sendGAEvent("STORE LEVEL - 1", "", () => localStorage.setItem("storeLevel1EventSent", true))
                //     //
                // }
            } else {
                this.setState({showFailscreen: true})
                this.sendGAEvent("STORE INFO FETCH - FAILED",message)
            }
        });

        // this.timeout = setTimeout(() => {
        //     if(!this.props.storeItemStoreItemTypeInfo.length > 0){
        //         this.setState({showFailscreen: true, showLoader: false})
        //     }
        // }, 10000)
    }

    async componentDidMount () {

        // if(this.props.storeItemStoreItemTypeInfo.length > 0 && this.state.showLoader){
        //     console.log("hcommerce is resetting",this.props.storeItemStoreItemTypeInfo.length)
        //         this.setState({showLoader: false})
        //     }

        // setTimeout(() => {
        //     console.log("this.props.storeItemStoreItemTypeInfo.length",this.props.storeItemStoreItemTypeInfo.length)
        //     if(!this.props.storeInfo.sku){
        //         this.setState({showFailscreen: true, showLoader: false})
        //     }
        // }, 10000)

        console.log("this.props.hcommerceWidget.storeSku, this.props.guestDetail",this.props.hcommerceWidget.storeSku, this.props.guestDetail)
        if(this.props.storeInfo.length == 0)
            await this.props.getStoreInfo(this.props.currentWidget.storeSku, this.props.guestDetail, (status, message) => {
                this.setState({showLoader: false})
                console.log("getStoreInfo res", status, message);
                if(status){
                    if(localStorage.getItem("storeInfoFetchEventSent") !== "true" && !this.storeInfoFetchEventSent){
                        this.storeInfoFetchEventSent = true
                        this.sendGAEvent("STORE INFO FETCH - SUCCESS", "", () => localStorage.setItem("storeInfoFetchEventSent", true))
                    }
                    // if(localStorage.getItem("storeLevel1EventSent") !== "true" && !this.storeLevel1EventSent){
                    //     this.storeLevel1EventSent = true
                    //     // Send Analytics
                    //     this.sendGAEvent("STORE LEVEL - 1", "", () => localStorage.setItem("storeLevel1EventSent", true))
                    //     //
                    // }
                } else {
                    this.setState({showFailscreen: true})
                    this.sendGAEvent("STORE INFO FETCH - FAILED",message)
                }
            })
        else
        this.setState({showLoader: false})

        // added support for "ALL"
        let selectedStore = this.props.StoreItemType.id ? this.props.StoreItemType : null
        if(selectedStore){
            this.selectStore(selectedStore)
        }

        let itemsHaveAddonsList = []
        for(let i=0; i<this.props.itemAddOnsInfo.length; i++) if(!itemsHaveAddonsList.includes(this.props.itemAddOnsInfo[i]['storeItemId'])) itemsHaveAddonsList.push(this.props.itemAddOnsInfo[i]['storeItemId'])

        this.setState({itemsHaveAddonsList:  itemsHaveAddonsList})

        hCommColor(this.props.menuColor);
        dynamicHeight();

        // Send Analytics
        console.log("storeLevel1EventSent *****************", localStorage.getItem("storeLevel1EventSent"))
        if(localStorage.getItem("storeLevel1EventSent") !== "true"){
            this.storeLevel1EventSent = true
            // Send Analytics
            this.sendGAEvent("STORE LEVEL - 1", "", () => localStorage.setItem("storeLevel1EventSent", true))
            //
        }
        //

        // $("#store_level1_widgets").attr("style","margin-bottom:7rem !important;")
    }

    componentDidUpdate(prePro,prevState) {
        console.log("componentDidUpdate")

        // if(this.props.storeItemStoreItemTypeInfo.length > 0 && this.state.showLoader){
        //     this.setState({showLoader: false})
        // }

        if(Object.keys(this.props.storeInfo).length > 0 && this.props.storeInfo.allowDayGuestOrdering != true && !this.props.guestIsLoggedIn){
            if(!this.state.showFailscreen && !this.state.showLoader){
                if(process.env.REACT_APP_INROOMTAB == "true") {
                    this.props.setLoginRequired(true)
                } else {
                    this.props.setRegPage(true);
                }
            }
        }

        if(this.props.hcommerceWidget && this.props.hcommerceWidget.storeSku){
            if(this.props.hcommerceWidget.storeSku !== prePro.hcommerceWidget.storeSku){
                if(this.props.storeInfo.length == 0){
                    this.props.getStoreInfo(this.props.currentWidget.storeSku, this.props.guestDetail, (status, message) => {
                        this.setState({showLoader: false})
                        console.log("getStoreInfo status", status);
                        if(status){

                            // added support for "ALL"
                            // this.selectStore(this.props.itemTypeList[0])
        
                            let itemsHaveAddonsList = []
                            for(let i=0; i<this.props.itemAddOnsInfo.length; i++) if(!itemsHaveAddonsList.includes(this.props.itemAddOnsInfo[i]['storeItemId'])) itemsHaveAddonsList.push(this.props.itemAddOnsInfo[i]['storeItemId'])
        
                            this.setState({itemsHaveAddonsList:  itemsHaveAddonsList})
                            if(localStorage.getItem("storeInfoFetchEventSent") !== "true" && !this.storeInfoFetchEventSent){
                                this.storeInfoFetchEventSent = true
                                this.sendGAEvent("STORE INFO FETCH - SUCCESS", "", () => localStorage.setItem("storeInfoFetchEventSent", true))
                            }
                            // if(localStorage.getItem("storeLevel1EventSent") !== "true" && !this.storeLevel1EventSent){
                            //     this.storeLevel1EventSent = true
                            //     // Send Analytics
                            //     this.sendGAEvent("STORE LEVEL - 1", "", () => localStorage.setItem("storeLevel1EventSent", true))
                            //     //
                            // }
                        } else {
                            this.setState({showFailscreen: true})
                            this.sendGAEvent("STORE INFO FETCH - FAILED",message)
                        }
                    });
                } else
                this.setState({showLoader: false})
            }
        }

        if(this.state.showAddOn !== prevState.showAddOn || this.state.clickSelectList != prevState.clickSelectList){
            if(this.state.showAddOn || this.state.clickSelectList){
                $("body").addClass("overlay-cast");
            }else{
                $("body").removeClass("overlay-cast");
            }
        }

        hCommColor(this.props.menuColor);
        dynamicHeight();
    }

    componentWillUnmount() {
        // this.props.setHcommerceWidget({})
    }

    goToMainMenu = (nextPage, subItem) => {
        this.props.selectedNavComponent('StoreLevel2');

        this.props.setSelectedSubItemList(extractIdsOfStoreData(subItem.id, this.props.storeItemStoreItemSubTypeInfo, 'storeItem', 'storeItemSubType'))
        this.props.selectedSubItem(subItem);
        this.props.changePage("StoreLevel2");
        //this.props.selectedStoreItemType(foodTime);
    }

    clickOnSelectList = () => {
        this.setState({ clickSelectList: !this.state.clickSelectList })
    }

    selectStore = (currentStore) => {


        this.props.setSelectedStoreItemList(extractIdsOfStoreData(currentStore.id, this.props.storeItemStoreItemTypeInfo, 'storeItem', 'storeItemType'))
        this.props.setSelectedStoreSubMenuList(extractIdsOfStoreData(currentStore.id, this.props.storeItemTypeSubTypeInfo, 'storeItemSubType', 'storeItemType'))

        this.props.selectedStoreItemType(currentStore);
        this.setState({ clickSelectList: false })
    }

    goToItemInfo = (nextPage, selecteditem) => {


        this.props.selectedFood(selecteditem);

        // for newer flow "addons with grouping", if store item has addon then we directly show AddOns list instead of itemInfo.
        if( this.props.addOnGroupTypeInfo.length > 0 && this.state.itemsHaveAddonsList.includes(selecteditem.id)) {
            this.selected = selecteditem;
            this.setState({showAddOn:true})
        } else {
            this.props.selectedNavComponent('StoreLevel1');
            this.props.changePage(nextPage);
        }
    }

    goBack = () => {

        if(this.state.showAddOn){
            this.setState({showAddOn: false})
            return;
        }

        if(this.props.hCommerceSavedOrders && this.props.hCommerceSavedOrders.length > 0){
            // this.props.setWarningPopup({show: true, msg: "There are items in the cart. Are you sure you want to exit?"})

            this.props.setShowCustomPopup(true,{
                htmlTagId:"items-in-cart",
                title: "Cancel order",
                subtitle:"",
                heading:"Are you sure you want to cancel?",
                subHeading:"There are items in your cart that will be removed when you exit.",
                primaryButtonText:"continue with order",
                secondaryButtonText:"Cancel order",
                secondaryButtonStyleIsUnderline:false,
                primaryOnClick:()=>{ this.props.setShowCustomPopup(false,{});
                
                },

                secondaryOnClick:()=>{
                    this.props.setShowCustomPopup(false,{});
                    this.props.setGoHome(true);
                    this.props.setHCommerceSavedOrders([]);
                    this.props.setSelectedList([]); 
                    },

                closeOnClick:()=>{ this.props.setShowCustomPopup(false,{}); }
        })  

        
        }  else {
            this.props.setGoHome(true);
        }
    }

    addOnCheckBoxCLick = (addOns, callback) => {
        this.setState({ addOn: addOns }, () => callback(true));
    }

    addToMyOrderCallback = () => {
        this.setState({showAddOn:false});
        this.setState({addOn:[]});
    }

    handleScroll = () => {
        hideScrolltoBottomHandler('storeItemList', (bool) => this.setState({ hideBottomArrow: bool }))
        hideScrolltoTopHandler("storeItemList",(bool) => this.setState({showScrollToTop:bool}))
    }

    render() {
        let imagePath;
        const { t } = this.props
        const add_to_cart = t('hcommerce.storelevel1.added_to_cart') 
        return (
            <div>
                <header class="inner-pages inner-pages-custom" id="marketplace" 
                    style={{
                        background: this.props.menuColor,
                        // `url('${this.props.currentWidgets.widgetHeaderImageUrl ? CMSPath + this.props.currentWidgets.widgetHeaderImageUrl 
                        //                     : this.props.currentWidgets.compImage ? this.props.currentWidgets.compImage : CMSPath + this.props.currentWidgets.btnImageUrl}')center center no-repeat`,
                        backgroundSize: "cover"
                    }}>

                    <a onClick={this.goBack} class="button-back"></a>
                    <div class="heading align-center">
                        {/* <p class="bold" style = {{color:"inherit",textShadow:"unset"}}>{this.props.currentWidgets.widgetTitle || "Food & Beverage"}</p> */}
                        {/* <p dangerouslySetInnerHTML={{__html: this.props.storeInfo.freeText}} ></p> */}

                        <div class="splash-brand">
                            <img src={getCdnUrl(CMSPath, this.props.logo)} />
                        </div>

                    </div>
                </header>{console.log("storeLevel1EventSent ****", localStorage.getItem("storeInfoFetchEventSent") !== "true", this.storeInfoFetchEventSent,
                localStorage.getItem("storeLevel1EventSent") !== "true", this.storeLevel1EventSent)}
                <section class="widgets" id = "store_level1_widgets">

                    <div class="widget-header">
                        { this.props.currentWidgets.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={getCdnUrl(CMSPath, this.props.currentWidgets.widgetHeaderImageUrl)} alt={this.props.currentWidgets.displayName} />
                            </div>
                        }
                        <div class="widget-header-title" dangerouslySetInnerHTML={{__html: this.props.currentWidgets.widgetTitle || "Food & Beverage"}} ></div>
                        <div class="widget-header-subtitle" dangerouslySetInnerHTML={{__html: this.props.storeInfo.freeText}}></div>
                        <div class="widget-header-store-description" dangerouslySetInnerHTML={{__html: this.props.storeInfo.storeDescription}}></div>
                    </div>


                    <div class="tab-selection">
                        <ul class="tabs">

                            {this.props.itemTypeList.length > 0 && <li><a class={this.props.StoreItemType && !this.props.StoreItemType.id && "tab-selected"} onClick={() => this.selectStore({})}>All</a></li>}
                            {
                                this.props.itemTypeList.map((iterator) => {
                                    return (
                                        <li><a class={this.props.StoreItemType && this.props.StoreItemType.id == iterator.id && "tab-selected"} onClick={() => this.selectStore(iterator)}dangerouslySetInnerHTML={{__html: iterator.typeName}}></a></li>
                                    )
                                })
                            }
                        </ul>
                    </div>

                    {/* <div class="widgets user-info">
                        <div class="user-stay tile tile-container custom-select secondary">
                            <div className="select-selected"
                                onClick={this.clickOnSelectList}>
                                {this.props.StoreItemType.typeName ?
                                    this.props.StoreItemType.typeName : ""}
                            </div>
                            <div id="storeItemList" onScroll={this.handleScroll} className={
                                this.state.clickSelectList ? `select-items ${this.state.hideBottomArrow || "multi nav-down"} ${this.state.showScrollToTop && "multi nav-up"}` : "select-items select-hide"
                            }
                            >
                                {
                                    
                                    this.props.itemTypeList && this.props.itemTypeList.length > 0 ?
                                        this.props.itemTypeList.map((iterator) => {
                                            return (
                                                <div onClick={() => this.selectStore(iterator)} dangerouslySetInnerHTML={{__html: iterator.typeName}}>
                                                </div>
                                            )
                                        })
                                        : null
                                }
                            </div>
                        </div>
                    </div> */}


                {!this.props.StoreItemType || !this.props.StoreItemType.id ?

                    <div class="widgets">
                        <div class="row margin-bottom-2">
                                    {this.props.groupedStoreItemTypeList.map((iterator) => (
                                        <div class="row">
                                            <div class="col col-2 menu-items">
                                            <h3 dangerouslySetInnerHTML={{__html: iterator.typeName}}></h3>
                                            {
                                                iterator.itemSubTypeList.length > 0 ?
                                                    iterator.itemSubTypeList.map((iteratorSubMenuList) => {
                                                        imagePath = null;
                                                        if (iteratorSubMenuList.storeItemTypeImages && iteratorSubMenuList.storeItemTypeImages.length === 1) {

                                                            imagePath = `${CMSPath}${iteratorSubMenuList.storeItemTypeImages[0].imagePath}`
                                                        } else {
                                                            iteratorSubMenuList.storeItemTypeImages && iteratorSubMenuList.storeItemTypeImages.map((images) => {
                                                                if (images.imageType === "LARGE") {
                                                                    imagePath = encodeURI(`${CMSPath}${images.imagePath}`)

                                                                }
                                                            })
                                                        }

                                                        return (
                                                            <a class="tile-sm thumbnails tile-container"
                                                                onClick={() => { this.goToMainMenu("StoreLevel2", iteratorSubMenuList) }}
                                                            >
                                                                <img src={imagePath} />

                                                                <div class="thumb-text">
                                                                    <p class="thumb-heading" dangerouslySetInnerHTML={{ __html: `${iteratorSubMenuList.subTypeName}` }}></p>
                                                                    {/* <p>Some description here</p> */}
                                                                    <p class="addon-button">
                                                                        <span class="addon-price">{t('hcommerce.storelevel1.open')}</span>
                                                                        <span class="addon-icon">
                                                                            <i class="fas fa-list"></i>
                                                                        </span>
                                                                    </p>
                                                                </div>
                                                            </a>
                                                        )
                                                    })
                                                    : null
                                            }

                                            {
                                                iterator.storeItemList.map((iteratorStoreItem) => {
                                                    imagePath = null;
                                                    if (iteratorStoreItem.storeItemImages.length === 1) {
                                                        imagePath = `${CMSPath}${iteratorStoreItem.storeItemImages[0].imagePath}`
                                                    } else {
                                                        iteratorStoreItem.storeItemImages.map((images) => {
                                                            if (images.imageType === "LARGE") {
                                                                imagePath = encodeURI(`${CMSPath}${images.imagePath}`);
                                                                if (imagePath.indexOf('(') !== -1) {
                                                                    imagePath = imagePath.replace("(", "%28");
                                                                }
                                                                if (imagePath.indexOf(')') !== -1) {
                                                                    imagePath = imagePath.replace(")", "%29");
                                                                }
                                                            }
                                                        })
                                                    }
                                                    return (

                                                        <a class="tile-sm thumbnails tile-container" >
                                                            <img src={imagePath} onClick={() => { this.goToItemInfo("itemInfo", iteratorStoreItem) }} />
                                                            <div class="thumb-text" onClick={() => { this.goToItemInfo("itemInfo", iteratorStoreItem) }} >
                                                                <p class="thumb-heading" 
                                                                
                                                                dangerouslySetInnerHTML={{ __html: `${iteratorStoreItem.itemName}` }}></p>
                                                                <p class="addon-button" >
                                                                    <span class="addon-price" dangerouslySetInnerHTML={{ __html: `${this.props.currencyCode} ${formatPriceForDisplay(iteratorStoreItem.itemPrice, this.props.precisionLength)}` }}></span>
                                                                    {!this.props.storeInfo.disableAddRemoveItemsButtons && <span class="addon-icon" style={{ flex: "0" }} 
                                                                    onClick={(e) => {
                                                                        
                                                                        e.stopPropagation();
                                                                        if (!this.props.storeInfo.disableAddRemoveItemsButtons) {
                                                                            this.props.selectedFood(iteratorStoreItem);
                                                                            this.selected = iteratorStoreItem;
                                                                            this.state.itemsHaveAddonsList.includes(iteratorStoreItem.id) ?
                                                                                this.setState({ showAddOn: true }) : addToMyOrder(iteratorStoreItem, this.state, this.props.setHCommerceSavedOrders, this.props.setTotalOrderPrice, this.props.closeOrderPopUp, this.addToMyOrderCallback, `${add_to_cart}`)
                                                                        }
                                                                    }}
                                                                    >
                                                                        <i class="fas fa-plus" 
                                                                            
                                                                        ></i>
                                                                    </span>}
                                                                </p>
                                                            </div>
                                                        </a>
                                                    )
                                                })
                                            }
                                            </div>
                                        </div>
                                    ))}
                        </div>
                    </div>
                :
                    
                    <div class="widgets">
                        <div class="row margin-bottom-2">
                            <div class="row">
                                <div class="col col-2 menu-items">
                                    <h3 dangerouslySetInnerHTML={{__html: this.props.StoreItemType.typeName}} ></h3>
                                    {console.log("this.props.itemSubTypeList",this.props.itemSubTypeList, this.props.selectedStoreSubMenuList)}
                                    
                                    {
                                        this.props.itemSubTypeList.length > 0 ?
                                            this.props.itemSubTypeList.map((iterator) => {
                                                imagePath=null;
                                                if (iterator.storeItemTypeImages && iterator.storeItemTypeImages.length === 1) {
                                                    
                                                    imagePath = getCleanUrl(`${iterator.storeItemTypeImages[0].imagePath}`)
                                                } else {
                                                    iterator.storeItemTypeImages && iterator.storeItemTypeImages.map((images) => {
                                                        if (images.imageType === "LARGE") {
                                                            imagePath = encodeURI(getCleanUrl(`${images.imagePath}`))
        
                                                        }
                                                    })
                                                }
                                                // if (iterator.storeItemSubTypeImages.length === 0) {
                                                //     imagePath = defaultImage
                                                // }
                                                return this.props.selectedStoreSubMenuList.includes(iterator.id) && (
                                                    <a class="tile-sm thumbnails tile-container"
                                                        onClick={() => { this.goToMainMenu("StoreLevel2", iterator) }}
                                                    > 
                                                        <img src={imagePath}  />

                                                        <div class="thumb-text">
                                                            <p class="thumb-heading" dangerouslySetInnerHTML={{__html: `${iterator.subTypeName}`}}></p>
                                                            {/* <p>Some description here</p> */}
                                                            <p class="addon-button">
                                                                <span class="addon-price">{t('hcommerce.storelevel1.open')}</span>
                                                                <span class="addon-icon">
                                                                    <i class="fas fa-list"></i>
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </a>
                                                )
                                            })
                                            : null
                                    }
                                    {
                                        this.props.storeItemList.map((iterator) => {
                                            imagePath=null;
                                            if (iterator.storeItemImages.length === 1) {
                                                imagePath = getCleanUrl(`${iterator.storeItemImages[0].imagePath}`)
                                            } else {
                                                iterator.storeItemImages.map((images) => {
                                                    if (images.imageType === "LARGE") {
                                                        imagePath = encodeURI(getCleanUrl(`${images.imagePath}`))
                                                        if (imagePath.indexOf('(') !== -1) {
                                                            imagePath = imagePath.replace("(", "%28");
                                                        }
                                                        if (imagePath.indexOf(')') !== -1) {
                                                            imagePath = imagePath.replace(")", "%29");
                                                        }
                                                        //console.log("imagePath", imagePath);
                                                    }
                                                })
                                            }
                                            // if (iterator.storeItemImages.length === 0) {
                                            //     imagePath = //getCleanUrl(`/../cmsData/hCommerce/defaultImages/default.png `)
                                            //     defaultImage
                                            // }
                                            return this.props.selectedStoreItemList.includes(iterator.id) && (

                                            <a class="tile-sm thumbnails tile-container" >
                                                <img src={imagePath}  onClick={() => {this.goToItemInfo("itemInfo", iterator) }}/>
                                                <div class="thumb-text"  onClick={() => { this.goToItemInfo("itemInfo", iterator) }} >
                                                    <p class="thumb-heading"  
                                                   
                                                     dangerouslySetInnerHTML={{__html: `${iterator.itemName}`}}></p>
                                                    <p class="addon-button" 
                                                            >
                                                        <span class="addon-price" dangerouslySetInnerHTML={{__html: `${this.props.currencyCode} ${formatPriceForDisplay(iterator.itemPrice, this.props.precisionLength)}`}}></span>
                                                        { !this.props.storeInfo.disableAddRemoveItemsButtons && <span class="addon-icon" style = {{flex:"0"}}
                                                         onClick={(e) => {
                                                            e.stopPropagation();
                                                            if(!this.props.storeInfo.disableAddRemoveItemsButtons){
                                                                this.props.selectedFood(iterator);
                                                                this.selected = iterator;
                                                                this.state.itemsHaveAddonsList.includes(iterator.id) ? 
                                                                this.setState({showAddOn:true}) : addToMyOrder(iterator,this.state,this.props.setHCommerceSavedOrders,this.props.setTotalOrderPrice,this.props.closeOrderPopUp,this.addToMyOrderCallback, `${add_to_cart}`)   
                                                            }
                                                        }}
                                                        
                                                        >
                                                            <i class="fas fa-plus"></i>
                                                        </span>}
                                                    </p>
                                                </div>
                                            </a>
                                            )
                                        })
                                    }


                                </div>
                            </div>
                        </div>
                    </div>
                }
                </section>

                {
                    this.state.showFailscreen &&  <SuccessFailScreen status={false} showTryAgain={true}  showClose={true} statusMessage1="We are unable to process the request at this moment." close={this.goBack} tryAgain={this.tryAgain} />
                }

                {
                    this.state.showAddOn && <AddOnPopup pageName="STORE LEVEL - 1" addOn = {this.state.addOn} backBtn = {() => this.setState({showAddOn:false})}
                    addOnCheckBoxCLick = {this.addOnCheckBoxCLick} addToMyOrder = {() => addToMyOrder(this.selected,this.state,this.props.setHCommerceSavedOrders,this.props.setTotalOrderPrice,this.props.closeOrderPopUp,this.addToMyOrderCallback, `${add_to_cart}`)}/>
                }
                {
                    // (this.state.getItemTypeLoading || 
                    this.state.showLoader &&
                    <Loader/>
                }
                {
                    console.log("this.props.showDisableOrderPopup",this.props.showDisableOrderPopup)
                }
                {
                    this.props.storeInfo.disableOrder && this.props.storeInfo.htmlInstruction && this.props.showDisableOrderPopup &&
                    <OrderDisabledPopup close={() => {this.props.setDisableOrderPopup(false)}} htmlString={this.props.storeInfo.htmlInstruction}/>
                }

            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        currentWidget: state.store.sideNavBar.currentWidget,
        itemTypeList: state.store.Hcommerce.itemTypeList,
        groupedStoreItemTypeList: state.store.Hcommerce.groupedStoreItemTypeList,
        currentWidgets: state.store.sideNavBar.currentWidget,
        StoreItemType: state.store.Hcommerce.StoreItemType,
        itemSubTypeList: state.store.Hcommerce.itemSubTypeList,
        menuColor: state.store.home.MenuColor,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        addOnGroupTypeInfo: state.store.Hcommerce.addOnGroupTypeInfo,
        storeItemList: state.store.Hcommerce.storeItemList,
        hcommerceWidget: state.store2.hcommerceWidget,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        SelectedFood: state.store.Hcommerce.SelectedFood,
        selectedStoreItemList: state.store.Hcommerce.selectedStoreItemList,
        selectedStoreSubMenuList: state.store.Hcommerce.selectedStoreSubMenuList,
        storeItemTypeSubTypeInfo: state.store.Hcommerce.storeItemTypeSubTypeInfo,
        itemAddOnsInfo: state.store.Hcommerce.itemAddOnsInfo,
        upsellItem: state.store.Hcommerce.upsellItem,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        deliveryLocations: state.store.Hcommerce.deliveryLocations,
        storeItemStoreUpsellItemInfo: state.store.Hcommerce.storeItemStoreUpsellItemInfo,
        storeItemStoreItemSubTypeInfo: state.store.Hcommerce.storeItemStoreItemSubTypeInfo,
        storeItemStoreItemTypeInfo: state.store.Hcommerce.storeItemStoreItemTypeInfo,
        subTypeSubTypeMapping: state.store.Hcommerce.subTypeSubTypeMapping,
        storeInfo: state.store.Hcommerce.storeInfo,
        hCommerceSavedOrders: state.store.Hcommerce.hCommerceSavedOrders,
        guestRegPag: state.store.deviceReg.guestRegPag,
        showDisableOrderPopup: state.store.showDisableOrderPopup,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        precisionLength: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.precisionLength : "",

    }
}
export default connect(
    mapStateToProps,
    {
        setRegPage,
        getItemType,
        changePage,
        selectedStoreItemType,
        getSubItemType,
        selectedSubItem,
        setDefaultSubTypeList,
        setGoHome,
        getItemListStoreLevel1,
        defaultStoreItemList,
        selectedFood,
        selectedNavComponent,
        setTotalOrderPrice,
        closeOrderPopUp,
        setHCommerceSavedOrders,
        setDeviceConfigFailed,
        getStoreInfo,
        setLoginRequired,
        setSelectedSubItemList,
        setSelectedStoreItemList, 
        setSelectedStoreSubMenuList,
        setDisableOrderPopup,
        setHcommerceWidget,
        setWarningPopup,
        sendAnalytics,
        setShowCustomPopup,
        setSelectedList
    }
)(withTranslation('translations')(StoreLevel1));